"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currenciesMocks = void 0;

var _msw = require("msw");

var getCurrenciesMock = _msw.rest.get('/api/v1/currencies', function (req, res, ctx) {
  return res(ctx.json({
    data: [{
      id: 1,
      name: 'US dollar',
      sign: '$',
      image: 'https://qa.alycedev.com/images/us-flag.png',
      code: 'USD'
    }]
  }));
});

var currenciesMocks = [getCurrenciesMock];
exports.currenciesMocks = currenciesMocks;